//LOCAL CONFIG
//export const VUE_APP_API_URL = "http://localhost:9000/";
export const VUE_APP_API_URL = "https://oeccabenin.bj/api/";
export const VUE_APP_BASE_URL = "/";
export const COOKIES_EXPIRE = "60MIN";
export const FEDAPAY_TOKEN_SANDBOX = 'pk_sandbox_46zArK325Mmf2GnMtHzlDDxF';